<template>
    <div class="wechat-autoReply">
        <div class="header">
            <div class="left">
                <label>可设置关注回复、点击菜单回复、消息回复</label>
                <label>粉丝关注公众号、点击菜单、发送消息后，系统自动给粉丝发送回复</label>
            </div>
            <div class="right">
                <el-button type="primary" @click="openModel()">新增自动回复</el-button>
            </div>
        </div>
        <div class="search-panel">
            <label>公众号名称</label>
            <el-input placeholder="请输入公众号名称" v-model="appName" @keyup.enter.native="pageChange(1)"></el-input>
            <label>消息类型</label>
            <el-select v-model="messageType" placeholder="请选择消息类型">
                <el-option label="全部" value=""></el-option>
                <el-option label="文本消息" value="1"></el-option>
                <el-option label="图片消息" value="2"></el-option>
                <el-option label="图文消息" value="3"></el-option>
                <el-option label="模板消息" value="4"></el-option>
            </el-select>
            <label>事件类型</label>
            <el-select v-model="replyType" placeholder="请选择事件类型">
                <el-option label="全部" value=""></el-option>
                <el-option label="订阅回复" value="1"></el-option>
                <el-option label="消息回复" value="2"></el-option>
                <el-option label="菜单回复" value="3"></el-option>
            </el-select>
            <el-button class="add" type="warning" @click="pageChange(1)">查询</el-button>
        </div>
        <div class="body">
            <div class="page-title">自动回复配置列表</div>
            <el-table :data="tableData" border class="omtable" style="width: 100%">
                <el-table-column type="index"></el-table-column>
                <el-table-column prop="appName" label="公众号名称"></el-table-column>
                <el-table-column label="回复类型">
                    <template slot-scope="scope">
                        <div v-if="scope.row.messageType==1">文本</div>
                        <div v-if="scope.row.messageType==2">图片</div>
                        <div v-if="scope.row.messageType==3">图文</div>
                        <div v-if="scope.row.messageType==4">模板</div>
                    </template>
                </el-table-column>
                <el-table-column label="事件类型">
                    <template slot-scope="scope">
                        <div v-if="scope.row.replyType==1">订阅回复</div>
                        <div v-if="scope.row.replyType==2">消息回复</div>
                        <div v-if="scope.row.replyType==3">菜单回复</div>
                    </template>
                </el-table-column>
                <el-table-column prop="sort" label="回消息次序" width="110px"></el-table-column>
                <el-table-column prop="addedSum" label="消息内容">
                    <template slot-scope="scope">
                        <el-tooltip v-if="scope.row.messageType==1" popper-class="tooltip" effect="dark" :content="scope.row.text" placement="top">
                            <div class="line2">{{scope.row.text}}</div>
                        </el-tooltip>
                        <div v-if="scope.row.messageType==2">图片</div>
                        <div v-if="scope.row.messageType==3">图文</div>
                        <div v-if="scope.row.messageType==4">模板</div>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="110px"></el-table-column>
                <el-table-column prop="updateTime" label="更新时间" width="110px"></el-table-column>
                <el-table-column prop="sendStatus" label="状态">
                    <template slot-scope="scope">
                        <div v-if="scope.row.enable" style="color:#1E95FE">已启用</div>
                        <div v-else style="color:#F56C6C">已禁用</div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="200px">
                    <template slot-scope="scope">
                        <el-button type="primary" size="small" @click="openModel(scope.row)">编辑</el-button>
                        <el-button type="danger" size="small" @click="delData(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination class="page"  background layout="total,prev, pager, next" @current-change="pageChange" :page-size='10' :total="listCount">
            </el-pagination>
        </div>

        <el-dialog :title="form.id?'编辑自动回复':'新建自动回复'" class="auto-replay-form" width="880px" :visible.sync="formShow" top="5vh">
            <el-form :model="form" :inline="true" label-width="130px" ref='form' label-position="right">
                <el-form-item label="公众号" prop="subscriptionId" :rules="[rules.required('请选择公众号')]">
                    <el-select v-model="form.subscriptionId" placeholder="请选择公众号" @change="checkForm('subscriptionId')" >
                        <el-option
                            v-for="item in weChatList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="事件类型" prop="replyType" :rules="[rules.required('请选择事件类型')]">
                    <el-select v-model="form.replyType" placeholder="请选择事件类型" @change="checkForm('replyType')">
                        <el-option label="订阅回复" :value="1"></el-option>
                        <el-option label="消息回复" :value="2"></el-option>
                        <el-option label="菜单回复" :value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="回消息次序" prop="sort" :rules="[rules.required('请输入回消息次序'), rules.num()]">
                    <el-input placeholder="请输入回消息次序，如1,2,3" v-model="form.sort"></el-input>
                </el-form-item>
                <template v-if="form.replyType==1">
                    <el-form-item label="发送类型" prop="timingStatus" :rules="[rules.required('请选择发送类型')]">
                        <el-select v-model="form.timingStatus" placeholder="请选择发送类型" @change="checkForm('timingStatus')">
                            <el-option label="定时回复" :value="true"></el-option>
                            <el-option label="实时回复" :value="false"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="定时方式" v-if="form.timingStatus==1" prop="timingType" :rules="[rules.required('请选择定时方式')]">
                        <el-select v-model="form.timingType" placeholder="请选择定时方式" @change="checkForm('timingType')">
                            <el-option label="定时方式一" value="1"></el-option>
                            <el-option label="定时方式二" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="form-item" prop="timepick" :rules="[rules.required('请选择发送时间')]" v-if="form.timingType==1&&form.timingStatus==1">
                        <label>
                            发送时间
                            <el-tooltip class="item" effect="dark" content="例：若需5分钟后发送，则选择00:05:00" placement="top">
                                <i class="icon-wenhao"></i>
                            </el-tooltip>
                        </label>
                        <el-time-picker v-model="form.timepick" arrow-control type="time" value-format="HH:mm:ss" :default-value="defDate" placeholder="请选择发送时间"></el-time-picker>
                    </el-form-item>
                    <el-form-item class="form-item" prop="timeTpick1" :rules="[rules.required('请选择发送时间')]" v-if="form.timingType==2&&form.timingStatus==1">
                        <label>
                            发送时间
                            <el-tooltip class="item" effect="dark" content="指定日期时间例如[T1-08:30,T2-08:20]，关注后第一天8点半，第二天8点20发送此消息" placement="top">
                                <i class="icon-wenhao"></i>
                            </el-tooltip>
                        </label>
                        <el-select v-model="form.timeTpick1" placeholder="请选择" @change="checkForm('timeTpick')" style="width:100px">
                            <el-option label="T1" value="T1"></el-option>
                            <el-option label="T2" value="T2"></el-option>
                        </el-select>
                        <el-time-picker v-model="form.timeTpick2" arrow-control type="time" :default-value="defDate"
                                placeholder="请选择发送时间" style="width: 160px;" format="HH:mm" value-format="HH:mm"></el-time-picker>
                    </el-form-item>
                </template>
                <el-form-item  v-if="form.replyType==2" label="关键字回复" prop="keyword" :rules="[rules.required('请输入关键字回复')]">
                    <el-input placeholder="请输入关键字回复" v-model="form.keyword"></el-input>
                </el-form-item>
                <el-form-item  v-if="form.replyType==2" label="关键字匹配方式" prop="matchAll" :rules="[rules.required('请选择关键字匹配方式')]">
                    <el-select v-model="form.matchAll" placeholder="请选择关键字匹配方式" @change="checkForm('matchAll')">
                        <el-option label="全匹配回复" :value="true"></el-option>
                        <el-option label="模糊匹配回复" :value="false"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item  v-if="form.replyType==3" label="menuKey" prop="keyword" :rules="[rules.required('请输入menuKey')]">
                    <el-input placeholder="请输入menuKey" v-model="form.keyword"></el-input>
                </el-form-item>
                <el-form-item label="回复类型" prop="messageType" :rules="[rules.required('请选择消息类型')]">
                    <el-select v-model="form.messageType" placeholder="请选择消息类型" @change="clearMedia">
                        <el-option label="文本消息" :value="1"></el-option>
                        <el-option label="图片消息" :value="2"></el-option>
                        <el-option label="图文消息" :value="3"></el-option>
                        <el-option label="模板消息" :value="4"></el-option>
                    </el-select>
                </el-form-item>
                <!-- 文本 -->
                <el-form-item class="full" v-if="form.messageType==1" label="回复内容" prop="text" :rules="[rules.required('请输入消息内容')]">
                    <el-input type="textarea" placeholder="请输入消息内容" v-model="form.text" :autosize="{ minRows: 4}"></el-input>
                </el-form-item>
                <!-- 图片 -->
                <el-form-item class="full" v-if="form.messageType==2" label="回复内容" prop="subscriptionId" :rules="[rules.required('选择图片素材')]">
                    <div class="show-box" @click="$refs.mediaModal.open(2)" v-if="mediaData.id">
                        <img :src="mediaData.url" alt="">
                    </div>
                    <div class="select-btn" @click="$refs.mediaModal.open(2)" v-else>
                        <i class="icon-jia"></i>
                        <div>选择图片素材</div>
                    </div>
                </el-form-item>
                <!-- 图文 -->
                <el-form-item class="full" v-if="form.messageType==3" label="回复内容" prop="subscriptionId" :rules="[rules.required('选择图文素材')]">
                    <div class="article-btn" @click="$refs.mediaModal.open(1)" v-if="mediaData.id">
                        <articleDetail :item="mediaData" type="formLook"></articleDetail>
                    </div>
                    <div class="select-btn" @click="$refs.mediaModal.open(1)" v-else>
                        <i class="icon-jia"></i>
                        <div>选择图文素材</div>
                    </div>
                </el-form-item>
                <!-- 模板 -->
                <el-form-item class="full" v-if="form.messageType==4" label="回复内容" prop="standardTemplateId" :rules="[rules.required('选择模板素材')]">
                    <div class="article-btn" @click="$refs.mediaModal.open(3)" v-if="mediaData.id">
                        <templateDetail :item="mediaData" type="look"></templateDetail>
                    </div>
                    <div class="select-btn" @click="$refs.mediaModal.open(3)" v-else>
                        <i class="icon-jia"></i>
                        <div>选择模板素材</div>
                    </div>
                </el-form-item>
                <!-- <el-form-item label="渠道编号" prop="subscriptionId" :rules="[rules.required('请输入渠道编号')]">
                    <el-input placeholder="请输入渠道编号" v-model="form.channel"></el-input>
                </el-form-item> -->
                <el-form-item label="状态" >
                    <el-switch v-model="form.enable" active-text="启用" inactive-text="禁用"></el-switch>
                </el-form-item>
            </el-form>
            <div class="btn-list">
                <el-button type="warning" plain @click="formShow=false">取消</el-button>
                <el-button type="warning" @click="submitForm">确定</el-button>
            </div>
        </el-dialog>

        <mediaModal ref="mediaModal" @submit="submitMedia" :subscriptionId="form.subscriptionId"></mediaModal>
    </div>
</template>
<script>
import commom from "../../api/common";
import {ruleTool} from '@/api/mixins'
import mediaModal from "./components/mediaModal";
import articleDetail from "./components/articleDetail";
import templateDetail from "./components/templateDetail";
//当前实例组件
export default {
    mixins: [ruleTool],
    data: () => ({
        defDate: new Date(2020,5,18,0,0,0),
        userId:"",
        appName:"",//公众号名称
        messageType:"",//消息类型
        replyType:"",//事件类型
        listCount:0,
        tableData:[],
        pageNum:1,
        weChatList:[],//公众号列表
        form:{},
        formShow:false,
        mediaData:{},
    }),
    components: {mediaModal,articleDetail,templateDetail},
    mounted() {
        this.userId = this.$tools.getLocal("userinfo").id
        this.getWeChatList(_=>{
            this.getList();
        });
    },
    methods: {
        //验证单个字段
        checkForm(key){
            this.$refs.form.validateField(key)
        },
        // 提交表单
        submitForm(){
             this.$refs.form.validate((valid) => {
                if (valid) {
                    const data = Object.assign({}, this.form);
                    if(data.replyType == 1 && data.timingType == 2) {
                        data.timeTpick = data.timeTpick1 + "-" + data.timeTpick2;
                        data.timepick = "";
                    }
                    if(data.timingType == 1) {
                        data.timeTpick = "";
                    }
                    this.$http({
                        url:'/wechatthirdplat/customMessageReply',
                        type:'post',
                        params: data,
                    }).then((data)=> {
                        this.$message.success('保存成功');
                        this.formShow = false;
                        this.pageChange(1);
                    })
                } else {
                    this.$message.error('请输入正确的信息');
                }
            });

        },
        // 清除选取的素材
        clearMedia(){
            this.checkForm('messageType');
            this.$set(this.form,'text','');
            this.$set(this.form,'subscriptionMediaId','');
            this.$set(this.form,'standardTemplateId','');
            this.mediaData={}
        },
        // 选取素材
        submitMedia(data){
            this.mediaData = data;
            this.$set(this.form,'subscriptionMediaId',data.id);
            if(this.form.messageType==4){
                this.$set(this.form,'standardTemplateId',data.id);
            }
        },
        // 公众号列表
        getWeChatList(callback){
            const params = {
                userId:this.userId,
                pageSize:99,
                pageNum:1
            }
            this.$http({
                url:'/wechatthirdplat/subscription/read/list',
                type:'put',
                params: params,
            }).then((data)=> {
                this.weChatList = data.data;
                if(data.data.length == 1) {
                    this.subscriptionId = data.data[0].id;
                }
                callback&&callback()
            })
        },
        // 打开表单弹窗
        openModel(item={}) {
            item = Object.assign({},item);
            const defDate = new Date(2020,5,18,0,0,0);
            if(item.id){
                if(item.timeTpick) {
                    item.timingType = "2";
                    const date = item.timeTpick.split("-");
                    if(date.length == 2){
                        item.timeTpick1 = date[0];
                        item.timeTpick2 = date[1];
                    }
                }
                if(item.timepick) {
                    item.timingType = "1";
                }
                if(item.messageType == 2) {
                    this.mediaData.id = item.subscriptionMediaId;
                    this.mediaData.url = item.picUrl;
                }else if(item.messageType == 3){
                    if(item.articles){
                        item.articles = JSON.parse(item.articles);
                        this.mediaData = {
                            id: item.subscriptionMediaId,
                            title:item.articles[0].title,
                            thumb_url:item.articles[0].thumb_url,
                            digest:item.articles[0].digest,
                            url:item.articles[0].url,
                            articles:item.articles,
                        }
                    }else{
                        item.subscriptionMediaId = "";
                        item.articles = [];
                        this.mediaData = {}
                    }
                }else if(item.messageType == 4){
                    this.mediaData = JSON.parse(item.summary);
                }
                this.form = item;
            }else{
                this.form = {
                    enable:true,
                    userId:this.userId,
                    timepick:defDate,
                    timeTpick1:"T1",
                    timeTpick2:defDate,
                }
            }
            this.formShow = true;
        },
        delData(item){
            this.$confirm(
                '确认删除自动回复配置？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
            .then(()=> {
                this.$http({
                    url:'/wechatthirdplat/customMessageReply',
                    type:'delete',
                    params: {ids:item.id},
                }).then((data)=> {
                    this.pageNum = 1;
                    this.getList();
                    this.$message.success('删除成功');
                })
            });
        },
        pageChange(page){
            this.pageNum = page;
            this.getList();
        },
        getList(){
            const params = {
                userId:this.userId,
                appName:this.appName,
                messageType:this.messageType,
                replyType:this.replyType,
                pageSize:10,
                pageNum:this.pageNum
            }
            this.$http({
                url:'/wechatthirdplat/customMessageReply/read/customList',
                type:'put',
                params: params,
            }).then((data)=> {
                this.tableData = data.data;
                this.listCount = data.total;
            })
        }
    },
};
</script>
<style lang="scss">
@import "./autoReply";
</style>
